module.exports = __webpack_public_path__ + "media/images/connection-fb54e393346ab72ff8c6dcbd748aad6b.png";